import RetratoDeMentor from "@/components/mentor/RetratoDeMentor";

/**
 * SocratesAvatar — el retrato de un mentor de Academia Alpha, a cualquier tamaño.
 *
 * Es la única puerta: todo lo que enseña a un mentor en 2D pasa por aquí, y por eso cambiar
 * de cara se hace en un sitio. Los dibujos de trazo que vivían en este fichero se quitaron el
 * 3 de noviembre de 2026: si un retrato no carga, no se sirve el anterior.
 *
 * Props:
 *  - character: "socratico" | "filosofia" | "literatura" | "psicologia"
 *               | "cultura-clasica" | "musica"          (por defecto "socratico")
 *  - mood: "idle" | "thinking" | "happy" | "curious"     (por defecto "idle")
 *  - size: tamaño en px (por defecto 96)
 *  - dark: true si va sobre fondo oscuro (anillo rojo en el disco)
 *  - animate: false para versión estática (por defecto true)
 */

const BLACK = "#0B0B0B";
const RED = "#D10000";

// Cómo se nombra a cada uno ante quien no ve la imagen.
const CHARACTERS = {
  socratico: { label: "Sócrates, mentor de Academia Alpha" },
  filosofia: { label: "Alpha · Filosofía" },
  literatura: { label: "Alpha · Literatura" },
  psicologia: { label: "Alpha · Psicología" },
  "cultura-clasica": { label: "Alpha · Cultura Clásica" },
  musica: { label: "Alpha · Música" },
};

export default function SocratesAvatar({ character = "socratico", mood = "idle", size = 96, dark = false, animate = true }) {
  const quien = CHARACTERS[character] ? character : "socratico";
  return <RetratoDeMentor character={quien} size={size} dark={dark} label={CHARACTERS[quien].label}
                          mood={mood} animate={animate} tinta={BLACK} rojo={RED} />;
}

// Mapea la clave de un agente/curso a su personaje de la familia.
export function characterForAgent(agentKey) {
  if (!agentKey) return "socratico";
  return CHARACTERS[agentKey] ? agentKey : "socratico";
}
